import repository from '@/api/modules/Operations/Containers';
import it_repository from '@/api/modules/it';
import { createCrudStoreModule, makeAction } from '@/store/utils/createCrudModule';

export default createCrudStoreModule({
  entity: 'containers',
  repo: repository,
  extra: {
    state: {
      access: [],
      warehouse_lists: [],
      get_warehouse_item_stocks: [],
      get_items_by_model: [],
    },
    getters: {
      ACCESS_INBOUND:            state => state.access,
      GET_WAREHOUSE_ITEM_STOCKS: state => state.get_warehouse_item_stocks,
      GET_ITEMS_BY_MODELS:       state => state.get_items_by_model,
    },
    actions: {
      getWarehouseItemStocks: makeAction(it_repository, 'getwarehouseitemstocks', 'WAREHOUSE_ITEM_STOCKS'),

      getWarehouseItemStocksBatch({ commit }, payload) {
        return new Promise((resolve, reject) => {
          it_repository
            .getwarehouseitemstocksbatch(payload)
            .then(response => {
              if (response.status === 200) resolve(response.data);
            })
            .catch(reject);
        });
      },

      sendContainerEmail({ commit }, payload) {
        return new Promise((resolve, reject) => {
          repository
            .sendContainerEmail(payload)
            .then(response => {
              if (response.status === 200) resolve(response);
            })
            .catch(reject);
        });
      },

      uploadContainerFiles({ commit }, payload) {
        return new Promise((resolve, reject) => {
          repository
            .uploadContainerFiles(payload.data, payload.config)
            .then(resolve)
            .catch(reject);
        });
      },

      getContainerFiles({ commit }, payload) {
        return new Promise((resolve, reject) => {
          repository.getcontainerfiles(payload)
            .then(response => { resolve(response.data); })
            .catch(reject);
        });
      },
    },
    mutations: {
      ACCESS_INBOUND:         (state, data) => { state.access                      = data; },
      WAREHOUSE_LISTS:        (state, data) => { state.warehouse_lists             = data; },
      WAREHOUSE_ITEM_STOCKS:  (state, data) => { state.get_warehouse_item_stocks   = data; },
      ITEMS_BY_MODEL:         (state, data) => { state.get_items_by_model          = data; },
    },
  },
});
